import _ from "lodash";

export const debounceCategoryList = _.debounce(async (apiFunction, setData) => {
  try {
    const response = await apiFunction();

    if (response.status === "success") {
      setData(response.result.rows);
    }
  } catch (error) {
    console.log(error);
  }
}, 300);
